module.exports = __webpack_public_path__ + "img/r-16.ab57c78a.jpg";